import {
  Typography,
  IconButton,
  Switch,
  Grid,
  makeStyles,
  Box,
} from '@material-ui/core';

import DeleteIcon from '@material-ui/icons/Delete';

import { observer } from 'mobx-react';
import { TableCell, TableRow } from '@material-ui/core';
import { deleteIconButtonStyle } from '../../utils/constants';
import {
  createCurrencyField,
  createPercentageField,
  createSelectField,
  createTextField,
} from '../temp/componentBuiderTemp';
import { useBaseStore } from '@roc/feature-app-core';
import { FeeFormStore } from '../../stores/common/feeFormStore';
import { TextField } from '@roc/ui';

interface FeeItemProps {
  feeName?: string | null;
  store: FeeFormStore;
  showTogglePercentage?: boolean;
}

const useStyles = makeStyles(theme => ({
  label: {
    fontWeight: 'bold',
    fontSize: '1rem',
  },
  activeLabel: {
    color: theme.palette.primary.main,
  },
  inactiveLabel: {
    color: theme.palette.text.secondary,
  },
  deleteButton: deleteIconButtonStyle,
  noBorders: {
    border: 'none',
  },
  disabled: {
    background: 'transparent',
  },
}));

export const FeeItemFixed = observer(
  ({ store, feeName = null, showTogglePercentage = true }: FeeItemProps) => {
    const classes = useStyles();

    const feeKey = store.key;
    const displayPercentage = store.form.fields.usePercentage.value;
    const { globalStore } = useBaseStore();

    return (
      <TableRow>
        <TableCell
          component="th"
          scope="row"
          style={{ width: '20%' }}
          className={classes.noBorders}
        >
          <TextField
                testId={`name-${feeKey}`}
                variant={'standard'}
                label={''}
                value={feeName}
                fullWidth
              />
        </TableCell>
        <TableCell
          align="center"
          component="th"
          scope="row"
          style={{ width: '20%' }}
          className={classes.noBorders}
        >
          <Box>
            {displayPercentage &&
              createPercentageField({
                store,
                testId: 'lenderPoints',
                fieldName: 'lenderPoints',
                label: null,
                autoFocus: true,
                limitedPercentage: true,
              })}
            {!displayPercentage &&
              createCurrencyField({
                label: null,
                fieldName: 'lenderAmount',
                testId: 'lenderAmount',
                store,
              })}
          </Box>
        </TableCell>
        <TableCell
          component="th"
          scope="row"
          style={{ width: '20%' }}
          className={classes.noBorders}
        >
          {showTogglePercentage && (
            <Grid container alignItems="center" justifyContent="flex-start">
              <Grid item>
                <Typography
                  className={`${classes.label} ${
                    !displayPercentage
                      ? classes.activeLabel
                      : classes.inactiveLabel
                  }`}
                >
                  $
                </Typography>
              </Grid>
              <Grid item>

                  <Switch
                    checked={displayPercentage}
                    onChange={() => store.toggleTypeOfValue()}
                    color="primary"
                    inputProps={{ 'aria-label': 'controlled' }}
                  />

              </Grid>
              <Grid item>
                <Typography
                  className={`${classes.label} ${
                    displayPercentage
                      ? classes.activeLabel
                      : classes.inactiveLabel
                  }`}
                >
                  %
                </Typography>
              </Grid>
              <Grid item>

              </Grid>
            </Grid>
          )}
        </TableCell>
      </TableRow>
    );
  }
);
